import React from "react";
import Box from "components/common/Box";

/** Compact checkbox matching Figma signup mobile (16×16, #2977ec). */
const AuthCheckbox = ({ checked, onChange, ...rest }) => {
  return (
    <Box
      component="button"
      type="button"
      role="checkbox"
      aria-checked={checked}
      onClick={() =>
        onChange?.({ target: { checked: !checked } })
      }
      sx={{
        width: 16,
        height: 16,
        minWidth: 16,
        p: 0,
        m: 0,
        mr: "10px",
        mt: "1px",
        flexShrink: 0,
        borderRadius: "2.67px",
        border: "1px solid #2977ec",
        bgcolor: checked ? "#2977ec" : "transparent",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        boxSizing: "border-box",
        appearance: "none",
        WebkitAppearance: "none",
        outline: "none",
        "&:focus-visible": {
          boxShadow: "0 0 0 2px rgba(41, 119, 236, 0.35)",
        },
      }}
      {...rest}
    >
      {checked ? (
        <Box
          component="img"
          src="/images/signup/check.svg"
          alt=""
          aria-hidden
          sx={{ width: 12, height: 12, display: "block" }}
        />
      ) : null}
    </Box>
  );
};

export default AuthCheckbox;
